import { ActivatedRouteSnapshot } from '@angular/router';

import { RouteData } from './route.model';

export function extractShowProgressBar(route: ActivatedRouteSnapshot): boolean {
  const data = route.data as RouteData;
  if (!!data && data.showProgressBar) {
    return true;
  }

  for (const child of route.children) {
    const result = extractShowProgressBar(child);
    if (result) {
      return true;
    }
  }

  return false;
}

export function createShowProgressBar(): RouteData {
  return {
    showProgressBar: true,
  };
}

export function combineData(...data: RouteData[]): RouteData {
  const result = {};
  data.forEach((item) => {
    Object.assign(result, item);
  });

  return result;
}
